import { ViewModel, View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { IUnit } from "../iUnit";
import { UnitEditorViewModel, UnitInserter, UnitUpdater } from "../unitEditor/unitEditor-viewModel";
import { UnitManipulationView } from "./unitManipulation-view"
import { translate } from "src/common/utilities";

export class UnitManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("unitManipulation-viewModel.definitionUnit", {});
    }

    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.units = ObservableArray.create<unit>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new UnitManipulationView();
    }
    public getTypeId(): string {
        return "VM-A2704746-21E3-4ED0-B82D-CF303FE9E8F2"
    }

    public set units(v: ObservableArray<unit>) { this._units = v; } public get units(): ObservableArray<unit> { return this._units; } private _units: ObservableArray<unit>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    async refresh() {
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/UnitManipulationServices/GetAllUnits', {
                FurtherQueryInfo: filteringInformation
            });
            this.units.update(...result.Units.map((q, i) => {
                let r = new unit(this);
                r.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                r.id = q.Id;
                r.name = q.Name;
                r.symbol = q.Symbol;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
    async addNew() {
        let popup = new UnitEditorViewModel(this, new UnitInserter());
        let result = await this.showPopup(popup);
        if (result != null) {
            this.refresh();
        }
    }
    async edit(unit: unit) {
        let popup = new UnitEditorViewModel(this, new UnitUpdater());
        unit.cloneTo(popup);
        let result = await this.showPopup(popup);
        if (result != null) {
            this.refresh();
        }
    }
}


export class unit extends ViewModel implements IUnit {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: UnitManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set symbol(v: string) { this._symbol = v; } public get symbol(): string { return this._symbol; } private _symbol: string;

    private _typedParent: UnitManipulationViewModel;

    cloneTo(unit: IUnit) {
        unit.id = this.id;
        unit.name = this.name;
        unit.symbol = this.symbol;
    }
    edit() {
        this._typedParent.edit(this);
    }
}